import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { BackendService } from './backend.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DonateService {
  baseURL = `${environment.baseUrl}/`;
  constructor(
    private http: HttpClient,
    private backendService: BackendService,
  ) {}

  getRecentFinancialReport(): Observable<any> {
    return this.backendService.get(`${this.baseURL}financial_report/fetch`).pipe(
      map((res) => {
        const { data = [] } = res;
        const financialReport = `${decodeURI(res.data.financial_report)}?alt=media`;
        return { ...data, financialReport };
      }),
    );
  }

  stripeOneTimePayment(stripeTokenResponse: any, amount: number, email: string): Observable<any> {
    const body = {
      payment_method_id: stripeTokenResponse.id,
      payment_intent_id: stripeTokenResponse.id,
      email,
      currency: 'CAD',
      amount,
    };
    return this.http.post(`${this.baseURL}payment/one-time/`, body).pipe(map((res) => res));
  }
}
